const apiurl = 'https://www.htinfor.com/api/';
export default{
	apiurl
}



